// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"240":"312f4fa4","705":"97053ac2"}[chunkId] + ".js";
};